
export const euportal = {
  'euportal.title': 'Smart Irrigation Upgrade Grant',
  'euportal.subtitle': 'Application Form - Reference: EAGF/IRR/2024/03',
  'euportal.header': 'European Agricultural Guarantee Fund',
  'euportal.portalId': 'Portal ID: EAGF-24-ONLINE',
  'euportal.applicantInfo': 'Applicant Information',
  'euportal.applicantInfoDesc': 'Please provide accurate information about your farm.',
  'euportal.requiredDocs': 'Required Documentation',
  'euportal.uploadLandProof': 'Upload Land Ownership Proof',
  'euportal.uploadIrrigationForm': 'Upload Irrigation Declaration Form (signed PDF)',
  'euportal.dragDrop': 'Click to upload or drag and drop',
  'euportal.fileTypes': 'PDF, JPG or PNG (max. 10MB)',
  'euportal.pdfOnly': 'PDF only (max. 5MB)',
  'euportal.submitApp': 'Submit Application',
  'euportal.disclaimer': 'This is a simulated environment for training purposes only.',
  'euportal.privacy': 'Privacy Policy',
  'euportal.terms': 'Terms of Use',
  'euportal.contact': 'Contact',
  'euportal.accessibility': 'Accessibility',
  'euportal.downloadCompleted': 'Download completed PDF',
  'euportal.submitToPortal': 'Submit to EU Portal (simulated)',
  'euportal.appCompletedMessage': 'You\'ve completed your subsidy application with AgriTool Advisor',
} as const;
